import React, { useEffect, useContext } from 'react';
import {
    Container,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import EditServiceForm from './EditServiceForm';
import { isNumeric } from "helpers";
import { useParams, useNavigate } from "react-router-dom";
import SecureFetchContext from 'context/SecureFetchContext';
import getApiRoute from 'routes/apiRoutes';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function ServiceEditView() {
    const classes = useStyles();
    const { t } = useTranslation();
    const [service, setService] = React.useState({name: ''});
    let { id } = useParams();
    let navigate = useNavigate();
    const secureFetch = useContext(SecureFetchContext);

    useEffect(() => {
        if ( !isNumeric(id) ) {
            navigate('/404');
        }
        if ( service.id !== parseInt(id) ) {
            secureFetch( getApiRoute('admin_service', [id]) ).then(json => {
                setService(json);
            });
        }
    }, [id, navigate, secureFetch, service.id]);

    return (
        <Page
            className={classes.root}
            title={t('title.edit_service') + ' - ' + service.name}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('title.edit_service') + ' - ' + service.name}
                </Typography>
                <EditServiceForm service={service} />
            </Container>
        </Page>
    );
}